import { Flex, Icon } from '@kandji-inc/nectar-ui';
import { memo } from 'react';
import {
  getClassificationIcon,
  getClassificationLabel,
} from '../../../../common/utils/constants-getters';
import type {
  CellThreatDetailProps,
  CellThreatGroupProps,
  ThreatClassificationUnion,
} from '../../../../threat.types';

type CellThreatUnion =
  | CellThreatGroupProps<ThreatClassificationUnion>
  | CellThreatDetailProps<ThreatClassificationUnion>;

export type ClassificationCellProps = {
  classification: ThreatClassificationUnion;
};

export const ClassificationCell = memo(
  ({ classification }: ClassificationCellProps) => (
    <Flex
      gap="xs"
      alignItems="center"
      css={{ '& svg': { flexShrink: 0, height: 20, width: 20 } }}
    >
      <Icon name={getClassificationIcon(classification)} size="sm" />
      {getClassificationLabel(classification, true)}
    </Flex>
  ),
);

export const renderClassificationCell = (info: CellThreatUnion) => {
  const classification = info.getValue();
  if (!classification) return '-';

  return <ClassificationCell classification={classification} />;
};
